<template>
    <div>
        <h1  v-if="datas.question" class="mb-8 font-semibold text-base text-primary">{{ datas.question }}</h1>
            <div v-if="$store.state.currentStep === 'caisse_en_acier' || $store.state.currentStep === 'caisse_en_plastique'" class="inline-block"> <!-- Rajoute une notice sur l'étape -->
                    <p class="mt-6 mb-6 text-black p-2 text-left text-xs"><font-awesome-icon icon="fa-solid fa-circle-question" /> {{ $t("NousNeVendonsPasLesCaissesDe300LEt95LEnPieceDeRechange") }}</p>
            </div>
            <div v-if="$store.state.currentStep === 'poignees'" class="inline-block">
                    <p class="mt-6 mb-6 text-black p-2 text-left text-xs"><font-awesome-icon icon="fa-solid fa-circle-question" /> {{ $t("MerciDeMesurerLeDiametreExterieurDuChassisDeLaBrouette") }}</p>
            </div>
        <div>
            <div class="flex flex-wrap justify-center">
                <div v-bind:class="[datas.options.length%2 == 0 ? 'w-full lg:w-1/2' : 'w-full lg:w-1/3']" v-for="(option, index) in datas.options" :key="index" class="flex flex-col justify-center p-2">
                    <div v-if="option.images">
                        <div class="rounded-3xl border border-solid shadow-lg cursor-pointer flex items-center justify-end p-5 flex-initial gap-y-4 flex-col transition duration-300 delay-250 group" @click="$store.commit('setCurrentStep', option);" :class='[index === $store.state.steps.length -1 ? "current" : "previous"]'>
                            <img class="h-32 mx-auto object-contain transition duration-450 ease-in-out transform hover:scale-90" :src="getWPUrl() + option.images"/>
                            <button class="animate1 bg-secondary text-white text-sm px-5 py-1 group-hover:text-primary delay-0 mb-2 whitespace-normal">{{ option.name }}</button>                    
                        </div>
                    </div>
                    <div v-if="!option.images">
                        <button @click="$store.commit('setCurrentStep', option);" :class='[index === $store.state.steps.length -1 ? "current" : "previous"]' class="animate1 bg-secondary text-white text-sm px-5 py-1 transition duration-300 delay-250 hover:text-primary delay-0 mb-2 whitespace-normal">{{ option.name }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getWPUrl } from '../../utils'
    export default {
        props: {
            datas: Object,
        },
        methods: {
            getWPUrl,
        },
    }
</script>